class Channel {
  constructor(
    id,
    type,
    name,
    groupName,
    deviceName,
    deviceAssignmentId,
    deviceId,
    unit,
  ) {
    this.id = id;
    this.type = type;
    this.name = name;
    this.groupName = groupName;
    this.deviceName = deviceName;
    this.deviceAssignmentId = deviceAssignmentId;
    this.deviceId = deviceId;
    this.unit = unit;
  }
}
export default Channel;
